import qs from 'qs';

import sortedUniq from 'lodash/sortedUniq';
import union from 'lodash/union';
import remove from 'lodash/remove';
import compact from 'lodash/compact';

import {
  newOrderDetailData,
  returnOrderDetailData,
} from '@js/controller/OrderDetailController';
import {
  apiPostRefreshOrder,
  apiPostGetEntryNumbers,
  apiPostOrderReturn,
  apiGetReturnOrRefund,
  apiGetReturnBankIDWithJson,
  apiGetReturnRequestB2B,
} from './testJsonApi';

import * as constType from '../constants/actionsTypes';
// import { AllNewOrderListDetailData } from '../controller/OrderListController';

const orderDetailMiddleware = (store) => (next) => (action) => {
  // orderlistinfo jsp傳來訂單資料變數
  switch (action.type) {
    case 'MID_GET_ORDER_DETAIL_DATA': {
      store.dispatch({
        type: constType.GET_ORDER_DETAIL_DATA,
        // jsp傳入變數
        payload: returnOrderDetailData(orderDetailData),
      });

      return next(action);
    }
    case 'MID_POST_CHECK_REFRESH_ORDER': {
      const {
        requestData,
        checkedStatus,
      } = action.payload;

      apiPostRefreshOrder('post', requestData).then((res) => {
        if (res.data == '1') {
          alert('訂單狀態改變，將刷新頁面');
          window.location.reload();
        } else {
          store.dispatch({
            type: 'MID_POST_CHECK_RETURN_ENTRYNUMBERS',
            // jsp傳入變數
            payload: action.payload,
          });
        }
      })
        .catch((err) => {
          alert('很抱歉！目前系統忙碌中，請稍候再試。');

          store.dispatch({
            type: constType.POST_CHECK_RETURN_ENTRYNUMBERS,
            // jsp傳入變數
            payload: ['0', '1', '2'],
          });
        });
      store.dispatch({
        type: constType.UPDATE_REFRESH_RETURN_FLAG,
        payload: false,
      });

      return next(action);
    }

    case 'MID_POST_CHECK_RETURN_ENTRYNUMBERS': {
      const {
        requestData,
        checkedStatus,
      } = action.payload;

      apiPostGetEntryNumbers('post', requestData).then((res) => {
        const parsedRequestData = qs.parse(requestData);
        const { checkedEntryNumber } = parsedRequestData;

        const resPonseData = compact(res.data.split(','));

        let checkedArray = [];

        if (checkedEntryNumber.length) {
          checkedArray = checkedEntryNumber.split(',');
        }

        let finalCheckedArray;

        if (checkedStatus) {
          finalCheckedArray = sortedUniq(union(checkedArray, resPonseData));
        } else {
          finalCheckedArray = remove(checkedArray, (num) => !resPonseData.includes(num));
        }

        store.dispatch({
          type: constType.POST_CHECK_RETURN_ENTRYNUMBERS,
          payload: finalCheckedArray,
        });
      })
        .catch((err) => {
          alert('很抱歉！目前系統忙碌中，請稍候再試。');
          store.dispatch({
            type: constType.POST_CHECK_RETURN_ENTRYNUMBERS,
            // jsp傳入變數
            payload: ['0', '1', '2'],
          });
        });

      return next(action);
    }

    case 'MID_POST_ORDER_RETURN': {
      const requestData = {
        ...action.payload,
        orderGuid: '',
        confirmClase: '',
        CSRFToken,
      };

      const { orderId } = action.payload;
      const { orderEntries } = action.payload;

      delete requestData.orderId;

      store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: true });

      apiPostOrderReturn('post', qs.stringify(requestData)).then((res) => {
        if (res.data.rtnCode == 1) {
          checkReturnStatus(store, orderId, orderEntries);
        } else {
          alert(res.data.rtnMsg);
          store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
        }
      })
        .catch((err) => {
          alert('很抱歉！目前系統忙碌中，請稍候再試。');

          store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
        });

      return next(action);
    }

    case 'MID_UPDATE_RETURN_BANKID': {
      apiGetReturnBankIDWithJson('get')
        .then((res) => {
          if (res.status === 200) {
            store.dispatch({ type: constType.UPDATE_RETURN_BANKID, payload: res.data });
          } else {
            throw '很抱歉！目前系統忙碌中，請稍候再試。';
          }
        })
        .catch((err) => {

        });

      return next(action);
    }

    case 'MID_GET_RETURN_REQUESTB2B': {
      store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: true });
      apiGetReturnRequestB2B('get', action.payload)
        .then((res) => {
          const responseData = JSON.parse(res.data);

          if (responseData.rtnCode == 1) {
            const {
              statusDate,
              rtvFreightName,
              rtvStatusStr,
            } = responseData;

            const requestB2BData = {
              statusDate,
              returnCarrierName: rtvFreightName,
              returnStatus: rtvStatusStr,
              searchSuccess: true,
            };
            store.dispatch({ type: constType.GET_RETURN_REQUESTB2B, payload: requestB2BData });
          } else if (responseData.rtnCode == -99) {
            const requestB2BData = {
              searchSuccess: false,
            };
            store.dispatch({ type: constType.GET_RETURN_REQUESTB2B, payload: requestB2BData });
          } else {
            const requestB2BData = {
              searchSuccess: false,
              returnStatus: responseData.rtnMsg,
            };
            store.dispatch({ type: constType.GET_RETURN_REQUESTB2B, payload: requestB2BData });
          }
          store.dispatch({ type: constType.SHOW_RETURN_REQUESTB2B_MODAL, payload: true });
          store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
        })
        .catch((err) => {
          const requestB2BData = {
            searchSuccess: false,
          };
          store.dispatch({ type: constType.GET_RETURN_REQUESTB2B, payload: requestB2BData });
          store.dispatch({ type: constType.SHOW_RETURN_REQUESTB2B_MODAL, payload: true });
          store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
        });

      return next(action);
    }

    default:
      return next(action);
  }
};

// 舊版api發出後沒辦法及時返回正確的狀態，需要setTimeout重複去檢查
function checkReturnStatus(store, orderId, orderEntries) {
  const paramsData = {
    orderCode: orderId,
    orderEntries,
  };
  apiGetReturnOrRefund('get', paramsData).then((res) => {
    if (res.data) {
      alert('訂單取消退貨成功');
      store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
      location.reload();
    } else {
      setTimeout(
        () => {
          checkReturnStatus(store, paramsData.orderId, paramsData.orderEntries);
        },
        2000,
      );
    }
  })
    .catch((err) => {
      alert('很抱歉！目前系統忙碌中，請稍候再試。');
    });
}

export default orderDetailMiddleware;
